import { lazy, Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import Certificate from "../components/landing/Certificate";
import control from "../assets/functional-icon.png";
import { AnimatePresence, motion } from "framer-motion";

const FunctionalControl = lazy(
  () => import("../components/services/FunctionalControl"),
);
const Modal = lazy(() => import("../components/common/CustomModal"));

const RootLayout = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        setShowIcon(window.scrollY > 150);
        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>

      <AnimatePresence>
        {showIcon && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            onClick={() => setIsModalOpen(true)}
            className="fixed z-50 p-4 text-white transition-all bg-white rounded-full shadow-lg cursor-pointer bottom-6 right-6 hover:border hover:scale-105"
            aria-label="Functional & Annual Control"
            title="Functional and Annual Control"
          >
            <img
              src={control}
              alt="functional-annual-control"
              className="object-contain w-10 h-10"
            />
          </motion.div>
        )}
      </AnimatePresence>

      <Suspense fallback={null}>
        <Modal
          isOpen={isModalOpen}
          size="full"
          onClose={() => setIsModalOpen(false)}
        >
          <div className="h-[90vh] w-full overflow-auto">
            <FunctionalControl />
          </div>
        </Modal>
      </Suspense>

      <Certificate />
      <Footer />
    </>
  );
};

export default RootLayout;
